export const routes = [
    {
        name: 'Estadio',
        path: ['/', '/estadio', '/estadio-aguila'],
        page: 'estadio'
    },
    {
        name: 'Camerino',
        path: ['/camerino', '/estadio-aguila/camerino'],
        page: 'camerino'
    },
    {
        name: 'Menu',
        path: ['/menu'],
        page: 'menu'
    },
    {
        name: 'Sensei3D',
        path: ['/sensei3D'],
        page: 'noticias3D'
    },
    {
        name: 'Rubigol',
        path: ['/rubigol'],
        page: 'rubigol'
    },

    {
        name: 'Ranking',
        path: ['/estadio-aguila/ranking', '/estadio-aguila/premios', '/estadio-aguila/progreso', '/ranking'],
        page: 'ranking'
    },
    {
        name: 'tada',
        path: ['/tada', '/estadio-aguila/codigo-tada'],
        page: 'tada'
    },
    {
        name: 'tapa',
        path: ['/estadio-aguila/escanea-tapa', '/estadio-aguila/codigo-tapa'],
        page: 'tapa'
    },
    {
        name: 'Terminos',
        path: ['/terminos-y-condiciones/loyalty'],
        page: 'tyc'
    },
    {
        name: 'Habeas',
        path: ['/habeas-data/loyalty'],
        page: 'habeas'
    },
    {
        name: 'Instructions',
        path: ['/estadio-aguila/instrucciones'],
        page: 'instructions'
    },
    {
        name: 'Predicciones',
        path: ['/estadio-aguila/predicciones',],
        page: 'predicciones'
    },
    // {
    //     name: 'Registro',
    //     path: ['/estadio-aguila/registro'],
    //     page: 'registro'
    // },
    {
        name: 'Gracias',
        path: ['/estadio-aguila/registro/gracias'],
        page: 'gracias'
    },
    {
        name: 'loginv2',
        path: [
            '/estadio-aguila/iniciar-sesion',
            '/estadio-aguila/registro',
            '/estadio-aguila/recuperar-contrasena',
            '/estadio-aguila/correo-enviado',
            '/estadio-aguila/nueva-contrasena'
        ],
        page: 'loginv2'
    },
    {
        name: 'Interna Noticias',
        path: ['/estadio-aguila/noticia', '/estadio-aguila/noticia/1'],
        page: 'internaNoticias'
    },
    {
        name: 'Noticias',
        path: ['/home-noticias', '/estadio-aguila/noticias'],
        page: 'noticias'
    },
    {
        name: 'retoSemanal',
        path: ['/estadio-aguila/reto-semanal'],
        page: 'retoSemanal'
    },
    {
        name: 'guia',
        path: ['/estadio-aguila/guia', '/prediccion'],
        page: 'guia'
    },
    {
        name: 'limitePartidas',
        path: ['/estadio-aguila/limite-partidas'],
        page: 'limitAttempts'
    },
    {
        name: 'JuegoInfo',
        path: ['/estadio-aguila/juego-sin-sesion'],
        page: 'gameInfo'
    },
    {
        name: 'Tienda',
        path: ['/estadio-aguila/tienda', '/tienda'],
        page: 'tadaShop'
    },
    {
        name: 'Trivia',
        path: ['/estadio-aguila/trivia'],
        page: 'trivia'
    },
    {
        name: 'Loteria Trivia',
        path: ['/estadio-aguila/prediccion-nacional/trivia'],
        page: 'triviaLottery'
    },
    {
        name: 'Loteria',
        path: ['/estadio-aguila/prediccion-nacional/participar'],
        page: 'lottery'
    },
    {
        name: 'Copa América',
        path: ['/copa-america/registro-exitoso'],
        page: 'americaGracias'
    },
    {
        name: 'Copa América Trivia',
        path: ['/estadio-aguila/aguila-millonaria/trivia'],
        page: 'triviaAmerica'
    },
]